import { ManageTable, type ManageField } from '@/components/ManageTable'
import { Input } from '@/components/ui/input'
import { usePersistentState } from '@/hooks/usePersistentState'

export default function LoginLog() {
  const [username, setUsername, clearUsername] = usePersistentState(
    'admin:login-log:username',
    '',
  )
  const filters = username ? { username } : {}

  const fields: ManageField[] = [
    {
      desc: '名称',
      field: 'username',
    },
    {
      desc: 'meta_ip',
      field: 'meta_ip',
    },
    {
      desc: 'ip',
      field: 'ip',
    },
    {
      desc: 'type',
      field: 'type',
    },
    {
      desc: '更新时间',
      field: 'update_time',
    },
  ]

  return (
    <div className="h-full p-6 overflow-auto">
      <h1 className="text-2xl font-bold mb-6">登录日志</h1>
      <div className="mb-4">
        <Input
          placeholder="搜索用户名"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          className="max-w-sm"
        />
      </div>
      <ManageTable
        fields={fields}
        collect="login_log"
        filters={filters}
        onResetFilters={clearUsername}
      />
    </div>
  )
}
